<div class="search-traceability-content">
  <div class="buttons-area">
    <button
      class="button-export"
      *ngIf="tableData && tableData.length > 0"
      (click)="exportToExcel('Rastreabilidade')"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.053 3.68361H12.6706V2.17969L2.17969 3.79891V17.992L12.6706 19.7989V17.5698H19.053C19.2463 17.5796 19.4356 17.5125 19.5795 17.3831C19.7234 17.2537 19.8102 17.0725 19.821 16.8793V4.37351C19.8101 4.18038 19.7232 3.99941 19.5793 3.87014C19.4354 3.74087 19.2462 3.67381 19.053 3.68361ZM19.1538 16.994H12.6492L12.6385 15.8038H14.2054V14.4177H12.6265L12.6189 13.5986H14.2054V12.2125H12.607L12.5994 11.3935H14.2054V10.0074H12.5944V9.18832H14.2054V7.80222H12.5944V6.98316H14.2054V5.59706H12.5944V4.33697H19.1538V16.994Z"
          fill="white"
        />
        <path
          d="M15.0879 5.59375H17.8116V6.97985H15.0879V5.59375ZM15.0879 7.79954H17.8116V9.18565H15.0879V7.79954ZM15.0879 10.0053H17.8116V11.3914H15.0879V10.0053ZM15.0879 12.2111H17.8116V13.5972H15.0879V12.2111ZM15.0879 14.4169H17.8116V15.803H15.0879V14.4169Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.91866 7.6342L6.27074 7.55671L7.12068 9.89355L8.12497 7.46031L9.47705 7.38281L7.83515 10.7006L9.47705 14.0267L8.04747 13.9303L7.08224 11.3949L6.11638 13.8339L4.80273 13.7179L6.32871 10.78L4.91866 7.6342Z"
          fill="#004877"
        />
      </svg>
      <span>Exportar</span>
    </button>
    <button class="button-clean" (click)="cleanFilters()">
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.68589 0.924805L3.45013 5.63466C3.50712 5.77428 3.58605 5.83846 3.69321 5.87856C3.8006 5.91876 3.94021 5.9205 4.06431 5.8845C4.18841 5.84849 4.2895 5.77452 4.33265 5.71269C4.37588 5.65081 4.38749 5.62306 4.3496 5.52951L4.34806 5.5256L2.62275 0.924805H1.68589ZM4.84615 5.12461L4.90924 5.29275L4.90622 5.28496C5.01851 5.56241 4.96757 5.873 4.82125 6.08267C4.67493 6.29227 4.45971 6.42294 4.22647 6.49061C3.99323 6.55832 3.73472 6.5628 3.48883 6.47069C3.24293 6.37861 3.01379 6.17541 2.89341 5.87911L2.89173 5.87499L2.83277 5.71768C1.78201 6.40997 1.40748 7.18678 1.64586 8.12585C1.68747 8.28948 1.7607 8.55806 1.84601 8.89944C4.34185 8.71508 6.54253 8.06496 8.55152 7.09568C8.20596 6.61093 7.79643 6.19275 7.26846 5.88862C6.58032 5.49221 5.66927 5.184 4.84619 5.12457L4.84615 5.12461ZM8.89202 7.62471C6.82819 8.63182 4.557 9.31585 1.99297 9.51923C2.06109 9.82276 2.12989 10.1582 2.19265 10.5153C5.19933 10.1628 7.66433 9.59875 9.50046 8.81058C9.30772 8.40089 9.1114 7.99994 8.89202 7.62471ZM9.76592 9.37814C7.84989 10.2091 5.33636 10.7795 2.29114 11.1372C2.59345 13.2793 2.55711 15.9126 0.824951 17.0748C1.37097 17.0748 1.89524 17.0695 2.39978 17.0591C2.99848 16.1658 3.44919 14.7442 3.47638 14.0477C3.75391 14.6347 3.58702 16.1213 3.29649 17.0342C3.38828 17.0309 3.47889 17.0274 3.56924 17.0238C3.96605 16.5904 3.96269 16.0229 4.06324 15.3709C4.17479 15.8925 4.29815 16.5233 4.38222 16.9844C4.76054 16.9628 5.12564 16.9375 5.47647 16.9081C6.02618 16.1964 6.20304 15.1741 6.10169 13.92C6.24351 14.9372 6.40762 16.0921 6.50015 16.8056C6.8244 16.7678 7.13526 16.7256 7.43334 16.6793C7.60248 16.0226 7.29575 14.9859 7.36381 14.2484C7.73709 15.7555 8.11041 16.1868 8.4837 16.4871C8.66559 16.4482 8.84128 16.407 9.01169 16.3639C8.85396 15.8762 9.06448 15.5775 9.05129 14.9661C9.24081 15.6299 9.54211 15.9085 9.87109 16.1133C10.0894 16.0398 10.296 15.9617 10.4917 15.8791C10.138 15.6495 10.1523 14.9572 10.0762 14.3786C10.276 15.1373 10.5599 15.5118 10.8844 15.7005C11.8618 15.2181 12.5185 14.5982 12.9114 13.8248C12.6067 13.6913 12.2847 13.3703 11.9694 13.1225C12.4129 13.3839 12.7642 13.4935 13.0557 13.5046C13.1001 13.3925 13.1401 13.2777 13.175 13.1596C11.2847 12.477 10.4878 10.9218 9.76595 9.37807L9.76592 9.37814Z"
          fill="#FFF"
        />
      </svg>
      <span>Limpar filtros</span>
    </button>
  </div>

  <form [formGroup]="formTraceability" class="form-filter-area">
    <div class="form-group">
      <input
        type="date"
        class="form-input"
        id="startDate"
        name="startDate"
        formControlName="startDate"
        (change)="checkStartDate()"
        [max]="maxCompletionDate | date : 'yyyy-MM-dd'"
      />
      <label
        class="form-label"
        for="startDate"
        [ngClass]="{ focus: formTraceability.get('startDate')?.value }"
      >
        Período Data inicial
      </label>
      <span
        class="alert"
        *ngIf="
          formTraceability.get('startDate')?.getError('required') &&
          (formTraceability.get('startDate')?.touched ||
            formTraceability.get('startDate')?.dirty)
        "
      >
        Campo Obrigatório
      </span>
      <span
        class="alert"
        *ngIf="
          formTraceability.get('startDate')?.getError('invalidDate') &&
          (formTraceability.get('startDate')?.touched ||
            formTraceability.get('startDate')?.dirty)
        "
      >
        Data Inválida
      </span>
    </div>
    <div class="form-group">
      <input
        type="date"
        class="form-input"
        id="endDate"
        name="endDate"
        formControlName="endDate"
        [min]="minCompletionDate | date : 'yyyy-MM-dd'"
        [max]="maxCompletionDate | date : 'yyyy-MM-dd'"
      />
      <label
        class="form-label"
        for="endDate"
        [ngClass]="{ focus: formTraceability.get('endDate')?.value }"
      >
        Período Data final
      </label>
      <span
        class="alert"
        *ngIf="
          formTraceability.get('endDate')?.getError('required') &&
          (formTraceability.get('endDate')?.touched ||
            formTraceability.get('endDate')?.dirty)
        "
      >
        Campo Obrigatório
      </span>
      <span
        class="alert"
        *ngIf="
          formTraceability.get('endDate')?.getError('invalidDate') &&
          (formTraceability.get('endDate')?.touched ||
            formTraceability.get('endDate')?.dirty)
        "
      >
        Data Inválida
      </span>
    </div>

    
    
    <div
      class="select-container"
      tabindex="-1"
      *ngIf="typeProduct == 'Bovinos'"
    >
      <input
        type="text"
        class="form-input"
        id="sif"
        name="sif"
        formControlName="sif"
      />
      <label
        class="form-label"
        for="sif"
        [ngClass]="{ focus: formTraceability.get('sif')?.value }"
      >
        SIF
      </label>
    </div>
    <div
      class="select-container"
      tabindex="-1"
      *ngIf="
        typeProduct == 'Bovinos' ||
        typeProduct == 'Suínos' ||
        typeProduct == 'Ovos' ||
        typeProduct == 'FLV'
      "
    >
      <input
        type="text"
        class="form-input"
        id="car"
        name="car"
        formControlName="car"
      />
      <label
        class="form-label"
        for="car"
        [ngClass]="{ focus: formTraceability.get('car')?.value }"
      >
        CAR
      </label>
    </div>
   

    <div class="form-group" tabindex="-1">
      <input
        type="text"
        class="form-input"
        id="fiscal"
        name="fiscal"
        formControlName="fiscalNote"
      />
      <label
        class="form-label"
        for="fiscalNote"
        [ngClass]="{ focus: formTraceability.get('fiscalNote')?.value }"
      >
        Nota fiscal
      </label>
    </div>
    <app-product-select-filter
      *ngIf="!isCarrefour"
      #inputProduct
      (handleChangeProductValue)="changeProductValue($event)"
    ></app-product-select-filter>
    <div class="form-area" *ngIf="isCarrefour">
      <div class="form-group" class="input-product">
        <input
          type="text"
          class="form-input"
          id="name"
          name="name"
          formControlName="product"
        />
        <label
          class="form-label"
          style="left: 8px"
          for="name"
          [ngClass]="{
            focus:
              formTraceability.get('product')?.value &&
              formTraceability.get('product')?.value.length > 0
          }"
        >
          Nome do Produto
        </label>
      </div>
    </div>
    <app-provider-select-filter
      #inputProvider
      [isUserProvider]="isUserProvider"
      (handleChangeProviderValue)="changeProviderValue($event)"
    ></app-provider-select-filter>
    <button type="button" class="button search-button" (click)="getTableData()">
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0654 6.21923C11.0654 5.12969 10.6643 4.19769 9.8622 3.42323C9.06008 2.64877 8.0948 2.26154 6.96634 2.26154C5.83788 2.26154 4.8726 2.64877 4.07048 3.42323C3.26836 4.19769 2.8673 5.12969 2.8673 6.21923C2.8673 7.30877 3.26836 8.24078 4.07048 9.01523C4.8726 9.78969 5.83788 10.1769 6.96634 10.1769C8.0948 10.1769 9.06008 9.78969 9.8622 9.01523C10.6643 8.24078 11.0654 7.30877 11.0654 6.21923ZM15.75 13.5692C15.75 13.8755 15.6341 14.1405 15.4023 14.3643C15.1705 14.5881 14.896 14.7 14.5788 14.7C14.2495 14.7 13.975 14.5881 13.7554 14.3643L10.617 11.343C9.52519 12.0733 8.30829 12.4385 6.96634 12.4385C6.09407 12.4385 5.25993 12.275 4.46391 11.9482C3.6679 11.6213 2.98167 11.1796 2.40524 10.623C1.82882 10.0665 1.37134 9.40394 1.0328 8.63537C0.694262 7.8668 0.524994 7.06142 0.524994 6.21923C0.524994 5.37704 0.694262 4.57166 1.0328 3.8031C1.37134 3.03453 1.82882 2.37197 2.40524 1.81541C2.98167 1.25886 3.6679 0.817157 4.46391 0.490294C5.25993 0.163431 6.09407 0 6.96634 0C7.83861 0 8.67275 0.163431 9.46877 0.490294C10.2648 0.817157 10.951 1.25886 11.5274 1.81541C12.1039 2.37197 12.5613 3.03453 12.8999 3.8031C13.2384 4.57166 13.4077 5.37704 13.4077 6.21923C13.4077 7.5149 13.0295 8.68984 12.2731 9.74405L15.4115 12.7742C15.6371 12.9921 15.75 13.2571 15.75 13.5692Z"
          fill="white"
        />
      </svg>
      <span> Buscar </span>
    </button>
  </form>

  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8 custom-table"
    *ngIf="tableActive"
  >
    <ng-container
      matColumnDef="localDelivery"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Local de entrega</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.nomeCliente || "-" }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="datasProvider"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>
        Nome e Código do Fornecedor<span *ngIf="typeProduct == 'Bovinos'">
          e SIF</span
        >
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.nomeFantasiaFornecedor.toUpperCase() }}
        {{
          element.documentoFornecedor ? "-" + element.documentoFornecedor : ""
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="completionDate" class="column-table">
      <th mat-header-cell *matHeaderCellDef>Data de Recebimento</th>
      <td mat-cell *matCellDef="let element">
        {{ element.dataRecebimento | date : "dd/MM/yyyy" }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="datasProvider"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>
        Nome e Código do Fornecedor<span *ngIf="typeProduct == 'Bovinos'">
          e SIF</span
        >
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.nomeFantasiaFornecedor }}
        {{
          element.documentoFornecedor ? "-" + element.documentoFornecedor : ""
        }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="origin"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Origens</th>
      <td mat-cell *matCellDef="let element">
        <span>
          {{
            element.origins && element.origins.length > 0
              ? element.origins.length
              : "-"
          }}
        </span>
        <img
          style="cursor: pointer"
          style="margin-left: 4px; cursor: pointer"
          *ngIf="element.origins.length > 0"
          src="../../../assets/images/olho.png"
          (click)="openModal(element)"
        />
      </td>
    </ng-container>

    <ng-container
      matColumnDef="origin"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Origens</th>
      <td mat-cell *matCellDef="let element">
        <span>
          {{ element.origins?.length > 0 ? element.origins?.length : "-" }}
        </span>
        <img
          style="cursor: pointer"
          style="margin-left: 4px; cursor: pointer"
          *ngIf="element.origins?.length > 0"
          src="../../../assets/images/olho.png"
          (click)="openModal(element)"
        />
      </td>
    </ng-container>

    <ng-container
      matColumnDef="datasProduct"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Produto e código</th>
      <td mat-cell *matCellDef="let element">
        <span style="display: block; padding: 8px">
          {{ element.nomeProduto }} - {{ element.ean }}
        </span>
      </td>
    </ng-container>
    <ng-container
      matColumnDef="datasProduct"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Produto e código</th>
      <td mat-cell *matCellDef="let element">
        <span style="display: block; padding: 8px">
          {{ element.nomeProduto }} - {{ element.ean }}
        </span>
      </td>
    </ng-container>

    <ng-container
      matColumnDef="quantity"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Quantidade</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.receivement?.invoiceItem
            ? element?.receivement?.invoiceItem.receivedQuantity
            : "-"
        }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="blocked"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Bloqueado</th>
      <td mat-cell *matCellDef="let element">
        {{
          element.provider.places && element.provider?.places[0]?.blocked
            ? "Bloqueado"
            : "Não Bloqueado"
        }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="fiscalNote"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Nota fiscal</th>
      <td mat-cell *matCellDef="let element">
        {{ element.nf_fornecedor }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="fiscalNote"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Nota fiscal</th>
      <td mat-cell *matCellDef="let element">
        {{ element.nf_fornecedor }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="productionDate"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Data de produção</th>
      <td mat-cell *matCellDef="let element">
        {{
          (element?.origins[0]?.product?.lots?.productionDate
            | date : "dd/MM/yyyy") || "-"
        }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="productionDate"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Validade</th>
      <td mat-cell *matCellDef="let element">
        {{
          element.receivement.invoiceItem?.expirationDate
            ? (element.receivement.invoiceItem.expirationDate
              | date : "dd/MM/yyyy")
            : "-"
        }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="blocked"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Bloqueado</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.origins[0]?.provider?.places[0]?.blocked
            ? "Bloqueado"
            : "Não Bloqueado"
        }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="status"
      class="column-table"
      *ngIf="!isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Status de Rastreabilidade</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.origins?.length > 0 ? "Rastreável" : "Não rastreável" }}
      </td>
    </ng-container>

    <ng-container
      matColumnDef="status"
      class="column-table"
      *ngIf="isCarrefour"
    >
      <th mat-header-cell *matHeaderCellDef>Status de Rastreabilidade</th>
      <td mat-cell *matCellDef="let element">
        {{ element.origins?.length > 0 ? "Rastreável" : "Não rastreável" }}
      </td>
    </ng-container>

    <!-- Defining the columns to be displayed -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="9">Nenhum registro encontrado</td>
    </tr>
  </table>

  <div class="paginacao">
    <mat-paginator
      id="paginator"
      *ngIf="tableActive && length > 5"
      [pageSizeOptions]="[5, 15, 10, 25]"
      [length]="length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      (page)="getTableData($event)"
      showFirstLastButtons
      [ngStyle]="{ display: true ? 'inherit' : 'none' }"
    ></mat-paginator>
  </div>
</div>

<app-spinner *ngIf="loading"></app-spinner>
